import { Dialog } from "primereact/dialog";
import PropTypes from "prop-types";
import CustomeButton from "../../Button/index";

export default function DeleteModal({
  visible,
  isLoading,
  closeModal,
  deleteAddress,
  selectedAddress,
}) {
  return (
    <div className="modal-main-container card flex justify-content-center">
      <Dialog
        visible={visible}
        onHide={closeModal}
        className="user-delete-confirmation"
      >
        <p className="delete-dialog-heading mt-5">
          {`Are you sure you want to remove ${selectedAddress} Address?`}
        </p>
        <p className="delete-dialog-desc">
          This action is permanent and will delete the address from our records.
          Do you want to proceed?
        </p>
        <div className="flex justify-content-end mt-5">
          <CustomeButton
            label="Cancel"
            variant="outlined"
            className="mr-2"
            onClick={closeModal}
          />
          <CustomeButton
            label={!isLoading && "Yes, remove"}
            variant="remove"
            onClick={deleteAddress}
            loading={isLoading}
            disabled={isLoading}
          />
        </div>
      </Dialog>
    </div>
  );
}

DeleteModal.propTypes = {
  isLoading: PropTypes.bool,
  visible: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  deleteAddress: PropTypes.func.isRequired,
  selectedAddress: PropTypes.string,
};
